import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiMembersKnowledgeInsightPostNewType } from "~/domains";

const request = async (): Promise<ApiMembersKnowledgeInsightPostNewType> => {
  const response =
    await new ApiClient().get<ApiMembersKnowledgeInsightPostNewType>(
      "/api/members/knowledge_insight_posts/new",
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  config?: QueryConfigType<QueryFnType>;
};

export const useApisMembersKnowledgeInsightPostsNew = ({
  config = {},
}: PropsType = {}): UseQueryResult<ApiMembersKnowledgeInsightPostNewType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisMembersKnowledgeInsightPostsNew"],
    queryFn: request,
  });
};
